import React from 'react';
import { connect } from 'react-redux';
import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';
import { getDecodedString } from '../../modules/ajio-util/stringDecoder';

class BreadCrumb extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const newDesignLuxe = this.props.newDesignLuxe;
    let breadCrumb = this.props.breadcrumb;
    let length = breadCrumb.length;
    const marginTop = newDesignLuxe && this.props.isPriceReveal ? 50 : 0;

    return (
      <nav
        className={`${newDesignLuxe ? 'luxe-newdesign' : ''}  breadcrumb-section`}
        style={{ marginTop: `${marginTop}px` }}
        aria-label="Breadcrumb"
      >
        <ul className="breadcrumb-sec">
          <li className="breadcrumb-list" key="list" style={{
            fontWeight:'bold'
          }}>
            <a href="/" aria-label="Home" tabIndex={0} style={{marginRight:"7px"}}>
              Home
            </a>
            <span aria-hidden="true" >/</span>
          </li>
          {breadCrumb.length &&
            breadCrumb.map((list, i) => {
              let { name, url } = list;
              let index = i + 1;

              if (
                location.pathname.startsWith('/search') ||
                location.pathname.startsWith('/find')
              ) {
                name = list.name.split(':')[0] || list.name;
              }
              name = getDecodedString(name) || '';
              let lastElement = i+1 === breadCrumb.length
              return (
                <li className="breadcrumb-list" key={`list-${i}`} style={{
                  fontWeight:'bold'
                }}>
                  <a href={index === length ? '#' : url} aria-label={name} tabIndex={0} 
                  {...(lastElement && {'aria-current':"page"})}
                  style={{marginRight:"7px"}}
                  >
                    {name}
                  </a>
                  {!lastElement && <span aria-hidden="true" >/</span>}
                </li>
              );
            })}
        </ul>
      </nav>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { httpError = {}, flags = {} } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  return {
    newDesignLuxe
  };
};

export default BreadCrumb = connect(mapStateToProps)(BreadCrumb);
